import React from "react";
import { useTheme } from "../context/ThemeContext";
import { useLanguage } from "../context/LanguageContext";
import { Link } from "react-router-dom";

const Footer = () => {
  const { theme } = useTheme();
  const { language } = useLanguage();
  const isDark = theme === "dark";
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`
      relative 
      py-12 
      px-8 
      border-t-2
      ${isDark 
        ? "border-green-500/20 bg-black/50" 
        : "border-green-900/20 bg-white/50"
      }
    `}>
      <div className="max-w-[1600px] mx-auto">
        <div className="flex flex-col items-center justify-center space-y-6">
          {/* Company Info */}
          <div className="text-center space-y-4">
            <h3 className={`text-xl font-bold ${
              isDark ? "text-green-400" : "text-green-900"
            }`}>
              Dynovant Systems
            </h3>
            <p className={`${
              isDark ? "text-gray-300" : "text-gray-700"
            }`}>
              {language === "en" 
                ? "Transforming businesses through AI innovation" 
                : "Transformer les entreprises par l'innovation IA"}
            </p>
          </div>

          {/* Contact Info */}
          <div className="text-center space-y-2">
            <div className={`${
              isDark ? "text-gray-300" : "text-gray-700"
            }`}>
              <p>contact@dynovant.com</p>
              <p>Dubai, UAE / Paris, France</p>
            </div>
          </div>

          {/* Bottom Section with Copyright and Legal Links */}
          <div className={`
            pt-6 
            mt-6 
            border-t 
            w-full
            flex
            flex-col
            md:flex-row
            md:justify-between
            md:items-center
            gap-4
            ${isDark 
              ? "border-green-500/20" 
              : "border-green-900/20"
            }
          `}>
            {/* Copyright */}
            <p className={`
              text-center md:text-left
              ${isDark ? "text-gray-400" : "text-gray-600"}
            `}>
              © {currentYear} Dynovant Systems. {language === "en" ? "All rights reserved." : "Tous droits réservés."}
            </p>

            {/* Legal Links */}
            <div className="flex gap-4">
              <Link
                to="/privacy"
                className={`
                  text-sm
                  px-4
                  py-2
                  rounded-lg
                  transition-all
                  duration-300
                  border
                  text-center
                  md:text-right
                  ${isDark 
                    ? "text-gray-300 border-green-500/30 hover:border-green-400 hover:text-green-400 hover:bg-green-500/10" 
                    : "text-gray-700 border-green-900/30 hover:border-green-800 hover:text-green-900 hover:bg-green-900/10"
                  }
                `}
              >
                {language === "en" ? "Privacy Policy" : "Politique de Confidentialité"}
              </Link>
              <Link
                to="/terms"
                className={`
                  text-sm
                  px-4
                  py-2
                  rounded-lg
                  transition-all
                  duration-300
                  border
                  text-center
                  md:text-right
                  ${isDark 
                    ? "text-gray-300 border-green-500/30 hover:border-green-400 hover:text-green-400 hover:bg-green-500/10" 
                    : "text-gray-700 border-green-900/30 hover:border-green-800 hover:text-green-900 hover:bg-green-900/10"
                  }
                `}
              >
                {language === "en" ? "Terms of Service" : "Conditions d'Utilisation"}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 